<div class="route-container">
  <div class="child">
    <div class="not-found-container">
      <h2 class="not-found-status">404</h2>
      <p class="instructions">
        Something went wrong or this page doesn't exist anymore.
      </p>
      <div class="row">
        <button id="cancel-button" mat-raised-button (click)="back()">
          Go Back
        </button>
      </div>
    </div>
  </div>
</div>
